module.exports = __webpack_public_path__ + "img/0Q3A7086_L_WoodMatted.53895b2f.jpg";